'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024107 from "./presto.-Presto-Router$$anon$107.js";
import * as $j_presto$002e$002dSigning$002dPage$0024 from "./presto.-Signing-Page$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$106() {
  this.beD = null;
  this.bev = null;
  this.bew = false;
  this.beE = null;
  this.beF = false;
  this.beI = null;
  this.beB = null;
  this.beC = false;
  this.bex = null;
  this.bey = false;
  this.bez = null;
  this.beA = false;
  this.beG = false;
  this.beH = false;
  this.beD = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.beI = "SigningPage";
}
export { $c_Lpresto_PrestoRouter$$anon$106 as $c_Lpresto_PrestoRouter$$anon$106 };
$p = $c_Lpresto_PrestoRouter$$anon$106.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$106;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$106() {
}
export { $h_Lpresto_PrestoRouter$$anon$106 as $h_Lpresto_PrestoRouter$$anon$106 };
$h_Lpresto_PrestoRouter$$anon$106.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.beD;
});
$p.M = (function() {
  if ((!this.bew)) {
    this.bev = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bew = true;
  }
  return this.bev;
});
$p.O = (function() {
  if ((!this.beF)) {
    this.beE = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.beF = true;
  }
  return this.beE;
});
$p.D = (function() {
  return this.beI;
});
$p.t = (function() {
  if ((!this.beC)) {
    this.beB = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("token", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.beC = true;
  }
  return this.beB;
});
$p.N = (function() {
  if ((!this.bey)) {
    this.bex = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bey = true;
  }
  return this.bex;
});
$p.Q = (function() {
  if ((!this.beA)) {
    this.bez = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024107.$c_Lpresto_PrestoRouter$$anon$107();
    this.beA = true;
  }
  return this.bez;
});
$p.v = (function() {
  if ((!this.beH)) {
    this.beG = false;
    this.beH = true;
  }
  return this.beG;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee638) => ((p) => \u03b4scrutinee638.cHb(p)))($j_presto$002e$002dSigning$002dPage$0024.$m_Lpresto_SigningPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$106 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$106, "presto.PrestoRouter$$anon$106", ({
  NC: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$106 as $d_Lpresto_PrestoRouter$$anon$106 };
//# sourceMappingURL=presto.-Presto-Router$$anon$106.js.map
